package com.artvending.warden.screens.scanner

import androidx.compose.runtime.*
import com.artvending.warden.Failure
import com.artvending.warden.FailureException
import com.artvending.warden.FailureFromServer
import com.artvending.warden.GeolocationCalculator
import com.artvending.warden.Page
import com.artvending.warden.Point
import com.artvending.warden.PolLanguage
import com.artvending.warden.PoltLanguage
import com.artvending.warden.ScreenModel
import com.artvending.warden.Success
import com.artvending.warden.TimeInterval
import com.artvending.warden.UkrLanguage
import com.artvending.warden.allowDevice
import com.artvending.warden.avatar
import com.artvending.warden.createScanner
import com.artvending.warden.currentScreenModel
import com.artvending.warden.db
import com.artvending.warden.fixedInterval
import com.artvending.warden.geolocation
import com.artvending.warden.getDayMinutes
import com.artvending.warden.getTodayInfo
import com.artvending.warden.isSending
import com.artvending.warden.language
import com.artvending.warden.log
import com.artvending.warden.millisecondsToDateTime
import com.artvending.warden.now
import com.artvending.warden.pickTime
import com.artvending.warden.screens.home.HomeScreenModel
import com.artvending.warden.screens.sending.SendingScreenModel
import com.artvending.warden.screens.success.SuccessScreenModel
import com.artvending.warden.sendScannerPostRequest
import com.artvending.warden.sendingQueue
import com.artvending.warden.commonSettings
import com.artvending.warden.isGeolocationGetting
import com.artvending.warden.isWebVersion
import com.artvending.warden.showError
import com.artvending.warden.showErrorAndWait
import com.artvending.warden.showLocationWarning
import com.artvending.warden.showMessageAndWait
import com.artvending.warden.today
import com.artvending.warden.userId
import com.artvending.warden.deviceId
import com.artvending.warden.er
import com.artvending.warden.userPikalkaId
import com.artvending.warden.userSetted
import com.artvending.warden.workingCalendarId
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDateTime
import kotlin.text.split
import kotlin.text.startsWith
import kotlin.text.toInt
import kotlin.text.toLong

@OptIn(DelicateCoroutinesApi::class)
class ScannerScreenModel : ScreenModel() {
	var loaded by mutableStateOf(false)
	val scanner = createScanner()
	var showScanner by mutableStateOf(true)
	
	override val page: Page?
		get() = Page.SCANNER
	
	
	@Composable
	override fun Display(scope: Any?) {
		scope.ScannerScreen(this)
	}
	
	
	suspend fun send(geolocation: Point?, qrCode: String) {
		try {
			while (isSending)
				delay(500)
			
			isSending = true
			val result = sendScannerPostRequest(qrCode, geolocation)
			isSending = false
			
			if (result is Success) {
				val pickTime = pickTime!!
				val dayMinutes = pickTime.getDayMinutes()
				val oldFrom = fixedInterval?.from
				
				fixedInterval =
					if (oldFrom == null)
						TimeInterval(dayMinutes, null)
					else
						TimeInterval(oldFrom, dayMinutes)
				
				currentScreenModel = SuccessScreenModel(pickTime)
			}
			else
				showError(if (result is Failure) result.toString() else language.UNKNOWN_ERROR) {
					currentScreenModel = ScannerScreenModel()
				}
		} catch (e: Exception) {
			showError(e.toString()) { showScanner = true; scanner.start() }
			log("Error sending scanner post request: $e")
		}
	}
	
	
	suspend fun handleSetUserCommand(qrCode: String) {
		val parts = qrCode.split(" ")
		userId = parts[1].toInt()
		userPikalkaId = parts[2]
		workingCalendarId = parts[3].toInt()
		val languageStr = parts[4]
		deviceId = parts[5].toInt()
		
		when (languageStr) {
			"ukr" -> language = UkrLanguage()
			"pol" -> language = PolLanguage()
			"plt" -> language = PoltLanguage()
		}
		
		val ava = parts[6]
		avatar = if (ava == "null") "" else ava
		db.setParameter("user_id", userId.toString())
		db.setParameter("user_pikalka_id", userPikalkaId)
		db.setParameter("working_calendar_id", workingCalendarId.toString())
		db.setParameter("language", languageStr)
		db.setParameter("avatar", avatar)
		db.setParameter("device_id", deviceId.toString())
		getTodayInfo()
		currentScreenModel = HomeScreenModel()
		showMessageAndWait(language.DONE, language.SET_USER_SUCCESS)
		userSetted()
	}
	
	
	suspend fun handleFixingCommand(qrCode: String) {
		
		// Если пользователь не установлен, показыаем ошибку
		if (userPikalkaId == "" || userPikalkaId == "_") {
			showError(language.USER_DIDNT_SET_2) { showScanner = true; scanner.start() }
			return
		}
		
		isGeolocationGetting = true // Показываем, что мы ожидаем правильную геолокацию
		pickTime = try {
			//throw Exception("TEST")
			millisecondsToDateTime(qrCode.toLong() / (today.dayOfMonth + 1) * 1000)
		} catch (e: Exception) {
			//println("EXXXXX")
			showErrorAndWait(language.INCORRECT_QR)
			//println("SHOWED")
			showScanner = true
			scanner.start()
			
			return
		}
		
		currentScreenModel = SendingScreenModel()
		var done = false // Еще не отправили фиксацию
		val result = geolocation.getGeolocation()
		
		if (result != null && result.errorMessage != "")
			er(result.errorMessage)
		
		var location = result?.location // Берём начальную локацию
		
		// Если геолокация отключена, предлагаем её включить (асинхронно)
		if (location == null || location.x == 0.0 && location.y == 0.0)
			showLocationWarning()
		
		// Делаем максимум 20 попыток
		for (i in 1..20) {
			// Если мы на месте, посылаем фиксацию и прерываем цикл
			if (location != null && GeolocationCalculator.isInside(location)) {
				isGeolocationGetting = false
				
				try {
					val result = sendingQueue.fix(if (commonSettings.DEBUG_MODE && isWebVersion) Point(52.293707, 21.003275) else location, qrCode)
					
					if (result is Success)
						currentScreenModel = SuccessScreenModel(pickTime)
					else if (result is FailureFromServer) {
						showErrorAndWait(result.toString())
						currentScreenModel = ScannerScreenModel()
						showScanner = true
						scanner.start()
					}
					else
						if (result == null || result is FailureException) {
							if (commonSettings.USE_SENDING_QUEUE && !isWebVersion)
								currentScreenModel = SuccessScreenModel(pickTime, true)
							else {
								log(result?.errorMessage ?: language.UNKNOWN_ERROR)
								showErrorAndWait(result?.toString() ?: language.UNKNOWN_ERROR)
								currentScreenModel = ScannerScreenModel()
								showScanner = true
								scanner.start()
							}
						}
				} catch (e: Exception) {
					log(e)
					showErrorAndWait(language.UNKNOWN_ERROR)
					showScanner = true
					scanner.start()
				}
				
				done = true // Фиксацию отправили
				
				break
			}
			// Если мы не на месте (или геолокация всё еще отключена)
			else {
				delay(500) // Ждём
				location = geolocation.getGeolocation()?.location // Снова определяем локацию
			}
		}
		
		// Если прошли весь цикл (не удалось получить правильное положение)
		if (!done)
			showError(if (location == null || location.x == 0.0 && location.y == 0.0) language.GEOLOCATION_ERROR else language.USER_IS_OUTSIDE_OFFICE)
			{
				currentScreenModel = ScannerScreenModel()
			}
	}
	
	
	@OptIn(DelicateCoroutinesApi::class)
	fun qrCodeDetected(qrCode: String) {
		com.artvending.warden.launch {
			if (qrCode.startsWith("set-user"))
				handleSetUserCommand(qrCode)
			else
				if (allowDevice == true)
					handleFixingCommand(qrCode)
				else if (allowDevice == null) {
					showMessageAndWait(language.ERROR, language.OFFLINE_ERROR)
					showScanner = true
					scanner.start()
				}
				else {
					showMessageAndWait(language.WARNING, language.DEVICE_NOT_ALLOWED)
					showScanner = true
					scanner.start()
				}
		}
	}
	
	
	override fun enter() {
		super.enter()
		
		scanner.start()
		//showLocationWarning()
	}
	
	fun test() {
		pickTime = LocalDateTime.now()
		val pickTime = pickTime!!
		val dayMinutes = pickTime.getDayMinutes()
		fixedInterval = if (fixedInterval?.from == null) TimeInterval(dayMinutes, null) else TimeInterval(fixedInterval?.from, dayMinutes)
		currentScreenModel = SuccessScreenModel(pickTime)
	}
	
	
	fun reset() {
		GlobalScope.launch {
			currentScreenModel = null
			scanner.pause()
			delay(500)
			currentScreenModel = ScannerScreenModel()
		}
	}
	
	
	override fun exit() {
		super.exit()
		scanner.pause()
	}
}


@Composable
expect fun Any?.ScannerScreen(model: ScannerScreenModel)